import { styled } from "@mui/material";
import { Button } from "components/ui";

export const DialogStyledButton = styled(Button)`
  width: 80px;
  text-transform: none;
`;
